// @ts-check
import Popup from "Components/Common/popup";
import 'Styles/commonComponents/settings/textInputSetting.scss';
import IconsContainer from "Utils/IconsContainer";
import { observer } from "mobx-react";
import React from "react";

/**
 * @param {{
 * id?: string,
 * className?: string,
 * title: string,
 * helperText?: string | undefined,
 * value: string | null,
 * invalid?: boolean,
 * disabled?: boolean,
 * short?: boolean,
 * onChanged: (arg0: string) => void,
 * textOptions?: {
 *  maxLength?: number
 *  type?: import('react').HTMLInputTypeAttribute
 *  multiple?: boolean
 *  autoComplete?: import('react').HTMLInputAutoCompleteAttribute
 *  }
 * }} props 
 * @returns {React.JSX.Element}
 */
const TextInputSetting = (props) => {
    return (
        <div className={'setting-container textinput-setting ' + (props.className ? props.className : '')}>

            <div className='setting-title textinput-setting-title'>
                {props.title}
                {props.helperText ?
                    <Popup
                        popupText={props.helperText}
                        className='fast-info-popup'>
                        {IconsContainer.Get('ci-info')}
                    </Popup>
                    : ''}
            </div>

            <input
                id={props.id}
                className={`textinput-setting-input ${props.invalid ? 'invalid' : ''} ${props.short ? 'short' : ''}`}
                value={props.value ?? ''}
                disabled={props.disabled}
                onChange={(e) => props.onChanged(e.target.value)}
                maxLength={props.textOptions?.maxLength}
                type={props.textOptions?.type}
                multiple={props.textOptions?.multiple}
                autoComplete={props.textOptions?.autoComplete} />

        </div>
    )
}

export default observer(TextInputSetting);